import React, { Component } from 'react';

import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  continueBtn: {
    marginTop:'20px',
    width: '150px'
  },
  header: {
    fontSize: '1.5em',
    color: "black"
  },
  image: {
    width: '20%',
    marginBottom: '20px'
  },
  input: {
    marginTop:"20px",
    width:"300px",
    maxWidth:'70%',
    backgroundColor: theme.palette.common.white,
    borderRadius: 25,
    boxShadow: '',
    paddingLeft: '20px',
    paddingRight: '20px',
    '& label': {
      paddingTop: '4px',
      paddingLeft:'26px'
    },
  },
  root: {
    marginTop:'120px'
  }
});

class Plate extends Component{
    constructor(props){
       super(props);

        this._handleContinue = this._handleContinue.bind(this);
      
        this.state = {};
        this.state.plate = this.props.plate;
    }
  
    _handleContinue(){
      if (!this.state.plate){return;}

      let plate = this.state.plate;

      plate = plate.toUpperCase();
      plate = plate.replace(/[^0-9a-zA-Z]/g, '');
      
      this.setState({plate: plate});

      this.props.handleContinue(plate);
    }
 
    render(){
      const { classes } = this.props;

      return (
          <div className={classes.root}>
              <img className={classes.image} src="images/vehicle.png" alt="vehicle"></img>
              <div className={classes.header}>{this.props.texts.vehiclePlate}</div>
              <TextField className={classes.input}
                label={this.props.texts.plate} 
                value={this.state.plate}
                onChange={e => this.setState({plate: e.target.value})}/>
              <br/>
              <Fab variant="extended"
                className={classes.continueBtn}
                color="primary"
                onClick={this._handleContinue}>
                {this.props.texts.continue}
              </Fab>
              <br/>
          </div>
      );      
    }
}

export default withStyles(styles)(Plate);


// WEBPACK FOOTER //
// ./src/components/Plate/index.js